/* eslint-disable  */
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { MoveDown, MoveUp } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { Input } from 'rsuite';
import { classes } from '../../../../Helpers';
import styles from './MeasurementBox.module.scss';

function ResultIcon(props) {
	const { result } = props;
	switch (result) {
		case 'PASS':
			return (
				<CheckCircleIcon
					className={classes(styles.pass, styles['result-icon'])}
				/>
			);
		case 'FAIL':
			return (
				<CancelIcon
					className={classes(styles.fail, styles['result-icon'])}
				/>
			);
		default:
			return <></>;
	}
}

function MeasurementBox(props) {
	const {
		measurements,
		classname,
		hideMin = false,
		hideMax = false,
		isEdit = false,
		updateValue = null,
		handleUpdateValue = () => { },
	} = props;
	const {
		min,
		max,
		title,
		measurement,
		result,
		unit,
		textToShow,
		minUnit,
		maxUnit,
		piecesCount,
		subTitle = null,
		colorBool = {},
		showSubTitle = false,
		calibration = null,
		// eslint-disable-next-line no-tabs
	} = measurements ?? {};
	const inputRef = useRef(null);

	useEffect(() => {
		if (isEdit && inputRef.current) {
			inputRef.current.focus();
		}
	}, [isEdit]);

	return (
		<div className={classes(classname, styles.root)}>
			<div className={styles.header}>
				<div className='flex flex-col justify-start gap-1'>
					<p
						className={styles.title}
						style={{
							display: 'flex',
							gap: '5px',
							alignItems: 'center',
						}}
					>
						<span>
							{title}
							{' '}
						</span>
						{showSubTitle && (
							<>
								<span className={`${colorBool?.color === 'red' ? 'text-red-600' : 'text-green-600'} flex items-center`}>
									{' '}
									(
									{subTitle}
									{colorBool?.arrow && (colorBool?.arrow === 'up' ? <MoveUp color='#FF0000' size={18} /> : <MoveDown color='#FF0000' size={18} />)}
									)
								</span>
							</>
						)}
					</p>
					{calibration && (
						<span className={styles.title}>
							Calibration Weight:
							{' '}
							{calibration}
						</span>
					)}
				</div>
				<div className={styles.values}>
					<p className={styles.ranges}>
						{Array.isArray(min) ? (
							<>
								{min[0]} {min[1]}
							</>
						) : (
							<>
								{typeof min === 'number' ? min?.toFixed(2) : min}
								{minUnit ?? unit}
							</>
						)}
						<br />
						{!hideMin && (
							<span className={styles.label}>Min</span>
						)}
					</p>
					<div className={styles.divider} />
					<div className={styles['current-value-container']}>
						{piecesCount !== null && piecesCount !== undefined && (
							isEdit ? (
								<div className='w-auto flex justify-center text-white gap-2 items-center'>
									<span className='text-base text-white'>Pieces Count: </span>
									<Input
										ref={inputRef}
										className='text-black w-[6rem] h-[2rem] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
										type='number'
										value={updateValue}
										onChange={(value) => handleUpdateValue(value)}
									/>
								</div>
							)
								: (
									<p className={styles['helper-text']}>
										Pieces Count:
										{' '}
										{piecesCount}
									</p>
								)
						)}
						<div className={styles['current-value']}>
							<div className={styles.values}>
								{measurement?.map((obj) => {
									const displayValue = obj?.displayValue ?? obj?.value;
									const displayUnit = obj?.displayUnit ?? unit ?? '';
									return (
										<div
											className={classes(
												styles[obj?.size],
												styles[obj?.color]
											)}
											style={{
												fontSize: '20px',
											}}
										>
											{displayValue ?? '-'}
											{displayUnit}
											<br />
										</div>
									);
								})}
							</div>
							<p className={styles.label}>
								{textToShow ?? 'Current'}
							</p>
						</div>
						{result != null && (
							<ResultIcon
								result={result === 'PASS' ? 'PASS' : 'FAIL'}
							/>
						)}
					</div>
					<div className={styles.divider} />
					<p className={styles.ranges}>
						{Array.isArray(max) ? (
							<>
								{max[0]} {max[1]}
							</>
						) : (
							<>
								{typeof max === 'number' ? max?.toFixed(2) : max}
								{maxUnit ?? unit}
							</>
						)}
						<br />
						{!hideMax && (
							<span className={styles.label}>Max</span>
						)}
					</p>
				</div>
			</div>
		</div>
	);
}

MeasurementBox.defaultProps = {
	measurements: {
		min: 0,
		max: 0,
		title: '',
		measurement: [],
		result: null,
	},
	unit: '',
};

export default MeasurementBox;
